import type { SkillTaxonomyDto } from '@eva/types/dto';
import { entitiesTypes } from 'shared/constants';

export const keyMaxNumberOfSelectedSkills: {
  [key: string]: keyof Omit<SkillTaxonomyDto['configuration'], 'pipelineWorkflowIds'>;
} = {
  [entitiesTypes.candidates]: 'candidateMaxNumberOfSelectedSkills',
};
